export default __webpack_public_path__ + "static/media/grafema_gim-tonico_12.0e283c4b.jpg";